import React from 'react'

function AchivementsUi(props) {
  const { data, handleItemEdit, handleAddItem } = props
  return (
    <div>
      {data &&
        data.map((item, questionIndex) => (
          <div key={questionIndex}>
            <div style={{ display: 'flex', gap: '5px' }}>
              <div>
                <h6>
                  {item && item.question_En}/{item && item.field_En}
                </h6>
                {item &&
                  item.answerItems_En &&
                  item.answerItems_En.map((answerItem, answerIndex) => (
                    <div key={answerIndex}>
                      <h6>Award_En {answerIndex + 1}</h6>
                      <label>Year: </label>
                      <input
                        type='text'
                        className='form-control'
                        value={answerItem.awardYear}
                        onChange={e =>
                          handleItemEdit({
                            questionIndex,
                            answerIndex,
                            field: 'awardYear',
                            value: e.target.value,
                            lang: 'En',
                          })
                        }
                      />
                      <br />
                      <label>Title: </label>
                      <input
                        type='text'
                        className='form-control'
                        value={answerItem.awardTitle_En}
                        onChange={e =>
                          handleItemEdit({
                            questionIndex,
                            answerIndex,
                            field: 'awardTitle_En',
                            value: e.target.value,
                            lang: 'En',
                          })
                        }
                      />
                      <br />
                      <label>Info: </label>
                      <textarea
                        type='text'
                        className='form-control'
                        value={answerItem.awardsBasicInfo_En}
                        onChange={e =>
                          handleItemEdit({
                            questionIndex,
                            answerIndex,
                            field: 'awardsBasicInfo_En',
                            value: e.target.value,
                            lang: 'En',
                          })
                        }
                      />
                      <br />
                    </div>
                  ))}
              </div>
              <div>
                <h6>
                  {item && item.question_Te}/{item && item.field_Te}
                </h6>
                {item &&
                  item.answerItems_Te &&
                  item.answerItems_Te.map((answerItem, answerIndex) => (
                    <div key={answerIndex}>
                      <h6>Award_Te {answerIndex + 1}</h6>
                      <label>Year: </label>
                      <input
                        className='form-control'
                        type='text'
                        value={answerItem.awardYear}
                        onChange={e =>
                          handleItemEdit({
                            questionIndex,
                            answerIndex,
                            field: 'awardYear',
                            value: e.target.value,
                            lang: 'Te',
                          })
                        }
                      />
                      <br />
                      <label>Title: </label>
                      <input
                        type='text'
                        className='form-control'
                        value={answerItem.awardTitle_Te}
                        onChange={e =>
                          handleItemEdit({
                            questionIndex,
                            answerIndex,
                            field: 'awardTitle_Te',
                            value: e.target.value,
                            lang: 'Te',
                          })
                        }
                      />
                      <br />
                      <label>Info: </label>
                      <textarea
                        type='text'
                        className='form-control'
                        value={answerItem.awardsBasicInfo_Te}
                        onChange={e =>
                          handleItemEdit({
                            questionIndex,
                            answerIndex,
                            field: 'awardsBasicInfo_Te',
                            value: e.target.value,
                            lang: 'Te',
                          })
                        }
                      />
                      <br />
                    </div>
                  ))}
              </div>
            </div>
            <button onClick={() => handleAddItem(questionIndex)} className='btn btn-primary'>
              Add Item
            </button>
          </div>
        ))}
    </div>
  )
}

export default AchivementsUi
